import { createContext, useContext } from "react";
/** Dependency-injection context carrying optional action-centre handler overrides. */
export var TaskActionsContext = /*#__PURE__*/createContext({});

/** Returns the injected action-centre handler overrides, or an empty set when none are provided. */
export function useTaskActions() {
  return useContext(TaskActionsContext);
}